import moment from 'moment';

const isDecimalValid = function (value) {
  const regexp = /^\d*\.?\d*$/;
  const status = value !== '' ? new RegExp(regexp).test(value) : false;
  return status;
};

const isNumberValid = function (value) {
  const regexp = /^[0-9]*$/;
  const status = value !== '' ? new RegExp(regexp).test(value) : false;
  return status;
};

const isValidString = function (value) {
  const regexp = /^[ a-zA-Z0-9\u00C0-\u00FF\u20AC\u00A2\u00A3\u00A6\u00A7\u00A9\u00B0\u00B4*_\-\\<>/;:.,'()\[\]+%&!?@=$#]*$/;
  const status = value !== '' ? new RegExp(regexp).test(value) : false;
  return status;
};

const isEmptyValues = function (value) {
  return value === undefined || value === null || value === NaN || (typeof value === 'object' && Object.keys(value).length === 0 || (typeof value === 'string' && value.trim().length === 0));
};

export { isDecimalValid, isNumberValid, isEmptyValues, isValidString };
